/**
 * @generated SignedSource<<2b6f66c247751819347dc21fbc11e3ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ListenPlayer_Piece$data = {
  readonly id: string;
  readonly file: {
    readonly audio_file_download_url: string | null;
    readonly duration: number;
    readonly notes: ReadonlyArray<{
      readonly bulb_id: string;
      readonly note_start: number;
      readonly note_duration: number;
      readonly midi_number: number;
    }>;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PieceRenderer_piece" | "PieceRendererStepThru_piece">;
  readonly " $fragmentType": "ListenPlayer_Piece";
};
export type ListenPlayer_Piece$key = {
  readonly " $data"?: ListenPlayer_Piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListenPlayer_Piece">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListenPlayer_Piece",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PieceRenderer_piece"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PieceRendererStepThru_piece"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicPieceFile",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "audio_file_download_url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MusicPieceFileNote",
          "kind": "LinkedField",
          "name": "notes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bulb_id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "note_start",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "note_duration",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "midi_number",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};

(node as any).hash = "144b3591b85c099f0410f5efba4e802b";

export default node;
